import { decamelizeKeys } from '../../lib';
import { getBackVersion } from '../../config';
import {
    IcatuCapSubscriberCompanySnapshot,
    IcatuCapSubscriberSnapshot,
} from '../../models/IcatuCap/Purchase/Subscriber';
import api from '../api';

const upsertSubscriber = (
    id: string,
    subscriber: IcatuCapSubscriberSnapshot
): Promise<IcatuCapSubscriberSnapshot> =>
    api.request<IcatuCapSubscriberSnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/cap/${id}/subscriber`,
        data: decamelizeKeys(subscriber),
    });

const upsertSubscriberCompany = (
    id: string,
    company: IcatuCapSubscriberCompanySnapshot
): Promise<IcatuCapSubscriberCompanySnapshot> =>
    api.request<IcatuCapSubscriberCompanySnapshot>({
        method: 'POST',
        url: `${getBackVersion()}/agent/cap/${id}/subscriber/company`,
        data: decamelizeKeys(company),
    });

export { upsertSubscriber, upsertSubscriberCompany };
